module.exports = __webpack_public_path__ + "img/Skirt-Front-B4-Da-Fb-Ge-Hc-Ia.484e4ef9.png";